






































































































































































import {
  computed, defineComponent, ref, useFetch, useMeta, useRoute, onMounted, toRef, useContext,
} from '@nuxtjs/composition-api';
import { getMetaInfo, getStoryMeta, getUrlMeta } from '~/helpers/getMetaInfo';
import { addBasePath } from '~/helpers/addBasePath';
import { SfImage, SfCarousel, SfCarouselItem } from '~/components/StorefrontUi';
import { useStoryblokBridge } from '@storyblok/nuxt-2';
import BlogArticleTile from '~/modules/storyblok/components/Blog/BlogArticleTile.vue';
import { useUiHelpers } from '~/composables';
import { CacheTagPrefix, useCache } from '@vue-storefront/cache';
import getFormattedDate from '~/helpers/getFormattedDate';
import BackButton from '~/components/BackButton.vue';
import { useUser } from '~/modules/customer/composables/useUser';
import useStoryblokView from '~/modules/storyblok/composables/useStoryblokView';
import { SHOP_TITLE } from '~/config/base';

export default defineComponent({
  name: 'BlogFile',
  components: {
    BackButton,
    SfImage,
    SfCarousel,
    BlogArticleTile,
    SfCarouselItem,
  },
  layout: 'basic',
  props: {
    currentStory: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const currentStory = toRef(props, 'currentStory');
    const route = useRoute();
    const path = route.value;
    const { addTags } = useCache();
    const { isAuthenticated } = useUser();
    const articles = ref([]);
    const { app } = useContext();
    const lang = computed(() => app.i18n.locale);
    const { getSelectedArticlesByUUIDs } = useStoryblokView();
    const uiHelpers = useUiHelpers();
    const metaInfo = () => {
      const urlMeta = getUrlMeta(uiHelpers.resolvePath());
      return getStoryMeta({ data: currentStory.value, baseData: urlMeta, lang: lang.value });
    };
    useMeta(() => getMetaInfo({ page: metaInfo() }));

    const shareOpenNewTab = (url:string) => {
      if (process.client) {
        const localPath = window.location.origin + path.fullPath;
        window.open(url + localPath, '_blank', 'noreferrer');
      }
    };

    const shareFn = () => {
      global.navigator.share({
        url: path.fullPath || '',
      });
    };
    const { fetch } = useFetch(async () => {
      if (!isAuthenticated.value) {
        addTags([{
          prefix: CacheTagPrefix.View,
          value: currentStory.value?.full_slug,
        }]);
      }
      const articlesUUIDs = currentStory.value?.content.readMore;
      if (articlesUUIDs.length <= 0) return;

      const { stories } = await getSelectedArticlesByUUIDs({
        uuids: articlesUUIDs,
        params: {
          sort_by: 'created_at:desc',
          per_page: 6,
        },
      });
      articles.value = stories;
    });
    fetch();

    onMounted(() => {
      if (currentStory.value?.id) {
        useStoryblokBridge(currentStory.value.id, (evStory) => { (currentStory.value = evStory); }, { preventClicks: true });
      }
    });

    const getArticleSchema = () => (JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: currentStory.value?.content?.title,
      image: currentStory.value?.content?.preview?.cached_url,
      datePublished: currentStory.value?.first_published_at || currentStory.value?.created_at,
      author: {
        '@type': 'Person',
        name: currentStory.value?.content?.author,
      },
    }));
    const getArticleBackground = computed(() => {
      if (!currentStory.value?.content?.heroBackgraund?.filename) {
        return addBasePath('/images/hero-background.jpg');
      }
      return currentStory.value?.content.heroBackgraund.filename;
    });
    return {
      articles,
      getFormattedDate,
      SfImage,
      shareFn,
      addBasePath,
      shareOpenNewTab,
      getArticleSchema,
      author: computed(() => (currentStory.value?.content.author !== '' ? currentStory.value?.content.author : 'Brak autora')),
      bgImage: getArticleBackground.value,
      date: computed(() => (currentStory.value?.content?.wpPublishDate || currentStory.value?.first_published_at || currentStory.value?.created_at)),
      secondaryTag: computed(() => (currentStory.value?.content.secondaryTag !== '' ? currentStory.value?.content.secondaryTag : `Blog ${SHOP_TITLE}`)),
      description: computed(() => currentStory.value?.content.description),
    };
  },
  head: {},
});
